import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../image/felt-teachers-logo.png';

const Footer = () => (
  <footer className="footer-distributed">
    <div className="footer-left">
      <h3>
        JustCoded Softskills Solutions
        <span>
          <img style={{ maxWidth: '50px' }} src={logo} alt='Softskills logo' />
        </span>
      </h3>

      <p className="footer-links">
        <NavLink to="/" className="link-1">
          Home
        </NavLink>

        <NavLink to="/aboutus">About Us</NavLink>

        <NavLink to="/contactus">Contact Us</NavLink>
      </p>

      <p className="footer-company-name">JustCoded Softskills Solutions &copy; 2022</p>
    </div>

    <div className="footer-center">
      <div>
        <i className="fa fa-map-marker"></i>
        <p>
          <span> 22 Nnobi Street Masha-Kilo</span> Surulere, Lagos, Nigeria
        </p>
      </div>

      <div>
        <i className="fa fa-phone"></i>
        <p>+234.813.950.3564</p>
        &nbsp
        <p>+234.809.623.2576</p>
      </div>

      <div>
        <i className="fa fa-envelope"></i>
        <p>
          <a href="mailto:taiwosunday99@gmail.com">taiwosunday99@gmail.com</a>
        </p>
      </div>
    </div>

    <div className="footer-right">
      <p className="footer-company-about">
        <span>About the company</span>
       At JustCoded Softskills Solutions, we teach you the latest software technology that drives today's business world. We give you access to choose from Frontend Stack, Backend Stack, Full Stack and Cloud Services.
        <br />
        <NavLink to="/aboutus" className="link">
          <i className="fas fa-arrow-right"></i>Learn More
        </NavLink>
      </p>

      <div className="footer-icons">
        <a href="https://www.facebook.com/sundayakinlose">
          <i className="fab fa-facebook"></i>
        </a>
        <a href="https://twitter.com/justCoding99?t=2Pq9jrjt14ma6guUa4HBlg&s=09">
          <i className="fab fa-twitter"></i>
        </a>
        <a href="https://www.linkedin.com/in/taiwo-akinlose-0a770217a/">
          <i className="fab fa-linkedin"></i>
        </a>
        <a href="https://github.com/taiwosunday99">
          <i className="fab fa-github"></i>
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
